import { config, handleResponse } from '../../_helpers';

export const routesServices = {
    load,
    getRouteByCode,
    createRoute,
    updateRoute,
    deleteRoute,
    activation,
    getRouteDestination,
    getRouteIsActive
};

function load(skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/Routes/load?skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/Routes/load?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}

function getRouteByCode(code) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Routes/getRoute/${code}`, requestOptions).then(handleResponse);
}

function createRoute(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/Routes`, requestOptions).then(handleResponse);
}

function updateRoute(payload, id) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/Routes/update/${id}`, requestOptions).then(handleResponse);
}

function deleteRoute(code) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(code),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };

    return fetch(`${config.apiUrl}/Routes/delete`, requestOptions).then(handleResponse);
}

function activation(id, isActive) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/Routes/activate/${id}?isActive=${isActive}`, requestOptions).then(handleResponse);
}

function getRouteDestination(OriginBranchCode) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Routes/getRouteDestination/?OriginBranchCode=${OriginBranchCode}`, requestOptions).then(handleResponse);
}

function getRouteIsActive() {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/Routes/getRouteIsActive`, requestOptions).then(handleResponse);
}